import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        this.setState({ error, info });
        // You could also log to an external service here
        console.error('ErrorBoundary caught', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 24 }}>
                    <h2>Ha ocurrido un error en la UI</h2>
                    <p style={{ color: '#666' }}>Se capturó una excepción durante el render. Detalle:</p>
                    <pre style={{ whiteSpace: 'pre-wrap', background: '#f8f8f8', padding: 12, borderRadius: 6 }}>{String(this.state.error && this.state.error.toString())}</pre>
                    <details style={{ marginTop: 12 }}>
                        <summary>Más información</summary>
                        <pre style={{ whiteSpace: 'pre-wrap' }}>{this.state.info && this.state.info.componentStack}</pre>
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}
